module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-1800.5302817b.svg";